<div class="search-box">
  <pos-app-lib-customer-ship-to-search (selectNewShipToCustomer)="selectCustomer($event)"> </pos-app-lib-customer-ship-to-search>
</div>
